/**
 * (c) Copyright Swisscom (Schweiz) AG. All rights reserved.
 *
 * This product is the proprietary and sole property of Swisscom (Schweiz) AG
 * Use, duplication or dissemination is subject to prior written consent of
 * Swisscom (Schweiz) AG.
 *
 * $Id: topnav.js
 */

/**
 * Initialize top navigation (1st level)
 */
window.scsHeaderJQuery(function($) {
	'use strict';

	// level 1 navigation: allow items to have different dividers on mouseDown (focused by mouse)
	var me = $('#scs-pageheader-topnav li.active');
	if (me.is(':last-child')) {
		me.after('<li class="dummy">&nbsp;</li>');
	}
	me.addClass('bigDivider').next().addClass('bigDivider');

	// megaDropDown
	// config
	var megaAnimInWait = 250;
	var megaAnimOutWait = 250;
	var megaAnimDurationPer100Px = 100;
	// definitions and declarations
	var megaAnimInTimeout;
	var megaAnimOutTimeout;
	var megaIsOpen = false;
	var megaDropDown = $('#scs-pageheader-megadropdown');
	var megaDropDownWrapper = megaDropDown.parent();
	var menuList = $('ul#scs-pageheader-topnav');
	var overItem;
	var hideInProgress = false;
	var activeItem = menuList.children('.active:first');
	var megaContentLoaded = [];
	var megaContentLoader = $('#scs-pageheader-megadropdown-loader');

	var listenToEscKey = function(e) {
		if (e.which === 27) {
			hideMega();
		}
	};

	// functions providing the possibility to show and hide the megaDropDown
	var showMega = function() {
		var mddIndex = overItem.data('mdd');
		var contentEl = $('#scs-pageheader-megadropdown-content-' + mddIndex);

		if (contentEl.length <= 0) return;

		// remove classes from active item if the active one is a neighbour of
		// the over item
		// reset active item -> necessary if the mega is already open
		activeItem.addClass('active bigDivider').next().addClass('bigDivider');
		if (overItem.prev().is('.active')) {
			overItem.removeClass('bigDivider');
		} else if (overItem.is('.active')) {
			overItem.removeClass('active').add(overItem.next()).removeClass('bigDivider');
		} else if (overItem.next().is('.active')) {
			overItem.next().removeClass('bigDivider');
		}
		// mark menu item as "over" item for megaDropDown
		menuList.find('.open').removeClass('open'); // reset open items
		overItem.addClass('open').find('a:first').addClass('open');
		menuList.addClass('megaDdVisible');
		// slide effect
		var isLoaded = megaContentLoaded[mddIndex];
		if (!megaIsOpen) {
			megaDropDown.css('height', 0).show();
		}
		megaDropDown.children().hide().attr('aria-hidden', 'true');
		var targetHeight = (isLoaded ? contentEl.show() : megaContentLoader.show()).height();
		var animTime = Math.abs(targetHeight - megaDropDown.height()) / 100 * megaAnimDurationPer100Px;
		megaDropDownWrapper.show();
		megaDropDown.animate({
			height : targetHeight
		}, animTime, function() {
			// show content if it is loaded now
			if (!isLoaded && megaContentLoaded[mddIndex] && mddIndex === overItem.data('mdd')) {
				var targetHeight = contentEl.height();
				var animTime = Math.abs(-megaDropDown.height()) / 100 * megaAnimDurationPer100Px;
				megaDropDown.animate({
					height : targetHeight
				}, animTime);
				megaContentLoader.hide();
				contentEl.show();
			}
		});
		contentEl.attr('aria-hidden', 'false');
		$(document).on('keydown', listenToEscKey);
		megaIsOpen = true;
	};

	var hideMega = function() {
		var mddIndex = overItem.data('mdd');
		var contentEl = $('#scs-pageheader-megadropdown-content-' + mddIndex);
		megaIsOpen = false;
		$(document).off('keydown', listenToEscKey);
		contentEl.attr('aria-hidden', 'true');
		menuList.find('.open').removeClass('open'); // reset open items
		activeItem.addClass('active bigDivider').next().addClass('bigDivider'); // reset
																				// active
																				// item
		megaDropDown.slideUp(megaDropDown.height() / 100 * megaAnimDurationPer100Px, function() {
			menuList.removeClass('megaDdVisible');
			megaDropDownWrapper.hide();
			hideInProgress = false;
		});
	};

	var requestShowMega = function() {
		var $this = $(this);
		overItem = $this.closest('li');
		window.clearTimeout(megaAnimInTimeout);
		window.clearTimeout(megaAnimOutTimeout);
		if (megaIsOpen) {
			showMega();
		} else {
			megaAnimInTimeout = window.setTimeout(showMega, megaAnimInWait);
		}
	};

	var requestHideMega = function() {
		hideInProgress = true;
		window.clearTimeout(megaAnimInTimeout);
		window.clearTimeout(megaAnimOutTimeout);
		if (megaIsOpen) {
			megaAnimOutTimeout = window.setTimeout(hideMega, megaAnimOutWait);
		}
	};

	// mouse events on menu items and the mega itself
	menuList.find('li').on('mouseenter', function() {
		requestShowMega.call($(this).find('a').get(0));
	}).on('mouseleave', function() {
		requestHideMega();
	});

	menuList.find('a').on('focus', function() {
		requestShowMega.call(this);
	}).on('blur', function() {
		requestHideMega();
	});

	megaDropDown.on('mouseenter focus', function() {
		window.clearTimeout(megaAnimOutTimeout);
	}).on('mouseleave blur', function() {
		requestHideMega();
	});

	// display the MDD on touchdevices without loading the target page on tap. If
	// the appropriate MDD is already opened and link is tapped again, load the
	// target page.
	if (('ontouchstart' in window) || window.DocumentTouch && document instanceof window.DocumentTouch) {
		menuList.find('a').each(function() {
			var $this = $(this),
				mddindex = $this.parent().data('mdd'),
				mddContent = $('#scs-pageheader-megadropdown-content-' + mddindex),
				url = $this.attr('href');

			if (mddContent.length) {
				$this.attr('href', 'javascript:;');
				$this.on('click', function() {
					if (mddContent.is(':visible')) {
						window.location.href = url;
					}
				});
			}
		});
	}

	// preload megaDropDown contents
	var processMddContentAfterLoad = function($this, i) {
		megaContentLoaded[i] = true;
		if (overItem && overItem.data('mdd') === i && !hideInProgress) {
			showMega();
		}
		$this.find('a').on('click', function(e) {
			window.scsHeader.siteCatalyst.trackClick(this, e, $(this).data('trackingTitle'), 'MDD');
		});
	};
	$('#scs-pageheader-megadropdown .mdd-content').each(function(i) {
		var $this = $(this);
		var url = $this.data('url');
		if (url) {
			megaContentLoaded[i] = false;
			$(window).on('load', function(e) {
				if (!$(e.target).is('iframe')) {
					$this.load(url, function() {
						$this.append('<div class="clear">&nbsp;</div>');
						processMddContentAfterLoad($this, i);
					});
				}
			});
		} else {
			processMddContentAfterLoad($this, i);
		}
	});

	var isPlaceholderSupported = function() {
		var input = document.createElement('input');
		return ('placeholder' in input);
	};
	var placeholderSupported = isPlaceholderSupported();

	var placeholderFieldFocussed = function() {
		var $this = $(this);
		if ($this.hasClass('placeholder')) {
			$this.removeClass('placeholder');
			if (!placeholderSupported && $this.val() === $this.attr('placeholder')) {
				$this.val('');
			}
		}
	};
	var placeholderFieldBlurred = function() {
		var $this = $(this);
		if ($this.val() === '') {
			if (!placeholderSupported) {
				$this.val($this.attr('placeholder'));
			}
			$this.addClass('placeholder');
		}
	};

	$('#scs-pageheader-search-field').focus(placeholderFieldFocussed).blur(placeholderFieldBlurred)
		.trigger('blur');

	$('input[name=qReferer]').val(document.location.href);
});



//////////////////
// WEBPACK FOOTER
// ./clientlibs/js/etc/designs/header/clientlibs/desktop/js/topnav.js
// module id = 101
// module chunks = 0